import { createContext, useState, ReactNode } from "react";
import Banner from "@/components/Banner";

type ErrorBannerContextType = {
  setError: (message: string) => void;
  clearError: () => void;
};

export const ErrorBannerContext = createContext<ErrorBannerContextType>({
  setError: () => {},
  clearError: () => {}
});

export default function ErrorBannerProvider({ children }: { children: ReactNode }) {
  const [error, setErrorMessage] = useState<string | null>(null);

  const setError = (message: string) => {
    setErrorMessage(message);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const clearError = () => {
    setErrorMessage(null);
  };

  return (
    <ErrorBannerContext.Provider value={{ setError, clearError }}>
      {error && <Banner variant="error" description={error} onClose={clearError} />}
      {children}
    </ErrorBannerContext.Provider>
  );
}
